import { render, staticRenderFns } from "./freeSwitchingRecord.vue?vue&type=template&id=39a1a5e2&scoped=true&"
import script from "./freeSwitchingRecord.vue?vue&type=script&lang=js&"
export * from "./freeSwitchingRecord.vue?vue&type=script&lang=js&"
import style0 from "./freeSwitchingRecord.vue?vue&type=style&index=0&id=39a1a5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1a5e2",
  null
  
)

export default component.exports